/* sidemenu */
$(function() {
    var toggle = $('.sidemenuToggle');
    toggle.click(function() {
        event.preventDefault();
        $(this)
            .parent()
            .toggleClass('__active');
        $(this)
            .siblings()
            .slideToggle();
    });
});
